import { Injectable } from '@angular/core';
import { UserClaims } from '@okta/okta-auth-js';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class UserService {
    private readonly _user: BehaviorSubject<UserClaims> = new BehaviorSubject({ sub: '' });
    readonly user$ = this._user.asObservable();

    constructor() {}

    setUser(user: UserClaims) {
        this._user.next(user);
    }

    getUser(): UserClaims {
        return this._user.getValue();
    }
}
